import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const VEHICLES_RESOURCE = 'vehicleTypes';

export default ComposedComponent => {
  class VehicleTypes extends Component {
    componentWillMount() {
      this.props.dispatchVehicleTypesGet();
    }
    getVehicleTypesForSelectOptions = () =>
      sortBy(this.props.vehicleTypesFetch.value || [], 'name').map(item => ({
        key: item.id,
        value: item.id,
        text: item.name,
      }));

    getVehicleTypesForSelectOptionsWithoutUnknown = () =>
      this.getVehicleTypesForSelectOptions().filter(x => x.value !== 0);

    render() {
      return (
        <ComposedComponent
          {...this.props}
          getVehicleTypesForSelectOptions={this.getVehicleTypesForSelectOptions}
          getVehicleTypesForSelectOptionsWithoutUnknown={
            this.getVehicleTypesForSelectOptionsWithoutUnknown
          }
        />
      );
    }
  }

  VehicleTypes.propTypes = {
    vehicleTypesFetch: PropTypes.object.isRequired,
    dispatchVehicleTypesGet: PropTypes.func.isRequired,
  };

  return reduxFetch(() => [
    {
      resource: VEHICLES_RESOURCE,
      method: 'get',
      request: () => ({
        url: apiRoutes.vehicleTypes(),
        comparison: new Date().toDateString(), // Only fetch once a day
      }),
    },
  ])(VehicleTypes);
};
